import { Alert, Box, Button, CardActionArea, CardContent, Grid, Paper, Typography } from "@mui/material";
import { useState } from "react";
import { OperacaoCategoriasProdutosContainer } from "../../../../../produtos/containers/OperacaoCategoriasProdutosContainer";
import { CheckoutPaper } from "../../../../components/CheckoutPaper";
import { ImprimirAnexoButton } from "../../../../components/ImprimirAnexoButton";
import { MesaPaper } from "../../../../components/MesaPaper";
import { MetodoPagamentoSelect } from "../../../../components/MetodoPagamentoSelect";
import { useOperacaoContext } from "../../../../contexts/OperacaoContext";
import { TipoPedido } from "../../../../enum/TipoPedido";
import { IProdutoPedido } from "../../../../interface/IProdutoPedido";
import { CategoriasContainer, Layer, ProdutosPaper } from "./styles";
import { useFetchCategorias } from "../../../../../produtos/hooks/useFetchCategorias";
import { CarrinhoMobilePaper } from "../../styles";
import { ProdutosCarrinhoContainer } from "../../../../../produtos/containers/ProdutosCarrinhoContainer";
import { useTamanhoTela } from "../../../../../core/hooks/useTamanhoTela";
import { TecladoNumeros } from "../../../../../core/components/TecladoNumeros";
import { useSnackbar } from "../../../../../core/contexts/SnackbarContext";
import { MesasContainer } from "../MesasContainer";
import { TipoAnexoPedido } from "../../../../enum/TipoAnexoPedido";
import { DividirPagamento } from "../DividirPagamento";
import { EmitirNotaFiscalModal } from "../EmitirNotaFiscalModal";
import { SwitchEmitirNotaFiscalPaper } from "../../../../components/SwitchEmitirNotaFiscalPaper";
import { TipoGatilhoComanda } from "../../../../enum/TipoGatilhoComanda";
import { IPagamentoPedido } from "../../../../interface/IPagamentoPedido";
import { SwitchImprimirAutomatico } from "../../../../components/SwitchImprimirAutomaticoPaper";
import { IDadosEmitirNotaFiscal } from "../../../../interface/IDadosEmitirNotaFiscal";
import { useNavigate } from "react-router-dom";
import { StatusPedido, StatusPedidoDescricao } from "../../../../enum/StatusPedido";

export const OperacaoMesa = () => {
    const [numero, setNumero] = useState<string>('');
    const navigate = useNavigate();
    const snackbar = useSnackbar();

    const {
        configuracao,
        alterarTipo,
        pedidos,
        fluxoContexto,
        abrirPedido
    } = useOperacaoContext();

    const handleNumeroChange = (novoNumero: string) => {
        setNumero(novoNumero)
    }

    const selecionarMesa = (id: number) => {
        if (!id || (id < 0) || (id > (configuracao?.numeroMesas ?? 0))) {
            return snackbar("Mesa não encontrada", { severity: "error" })
        }

        const pedidoMesa = pedidos.find(pedido => pedido.mesaId == id);
        if(!pedidoMesa) {
            abrirPedido({
                mesaId: id,
                status: StatusPedidoDescricao["Em andamento"]
            });
            return;
        }

        navigate(`/pedidos/operacao/edicao/${pedidoMesa.uuid}?redirect=/pedidos/operacao?tipo=mesa`);
    }



    const configuracoesComandaCozinha = fluxoContexto
        ?.configuracoesComandas
        ?.filter(config => config.gatilhos.includes(TipoGatilhoComanda.BOTAO_IMPRIMIR));

    return (
        <Grid
            container
            spacing={0}
            sx={{ width: "100%", height: "100%" }}
            justifyContent={"center"}
            alignItems={"center"}
        >
            <Paper variant="outlined" component={Grid} item xs={12} sm={12} md={4} sx={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }}>
                <TecladoNumeros
                    handleNumeroChange={handleNumeroChange}
                    concluir={() => selecionarMesa(Number(numero))}
                />
            </Paper>
            <Grid item xs={12} sm={12} md={8}>
                <MesasContainer
                    selecionarMesa={selecionarMesa}
                    configuracoes={configuracao}
                    pedidos={pedidos}
                    sm={2}
                />
            </Grid>
        </Grid>
    );
}